import type { IconDefinition } from '@fortawesome/angular-fontawesome';
import {
    faCircleCheck,
    faClipboardCheck,
    faComment,
    faFileLines,
    faPen,
    faPercent,
    faTriangleExclamation,
    faUser,
    faUsers,
} from '@fortawesome/pro-light-svg-icons';
import { KPI_CARD_STATUSES } from '@h20-shared/pulse-components/pulse-kpi-card';

/** The closed sets a KPI widget's dropdowns offer. */

/** The most cards an author may ask for. */
export const KPI_MAX_CARDS = 12;

/** How many cards a config that never named a count gets. */
export const KPI_DEFAULT_CARDS = 3;

/** `horizontal` fills a wrapping row; `vertical` stacks one card per row. */
export const KPI_DIRECTIONS = ['horizontal', 'vertical'] as const;

/** With a second number: `of` shows "{{numerator}} of {{denominator}}", `ratio` divides them. */
export const KPI_DISPLAYS = ['of', 'ratio'] as const;

/** The colors an icon can take. */
export const KPI_ICON_COLORS = KPI_CARD_STATUSES;

export const KPI_ICON_NAMES = [
    'user',
    'users',
    'percent',
    'file',
    'pen',
    'comment',
    'clipboard',
    'check',
    'warning',
] as const;
type KpiIconName = (typeof KPI_ICON_NAMES)[number];

/** The icon behind each name. */
export const KPI_ICONS: Readonly<Record<KpiIconName, IconDefinition>> = {
    user: faUser,
    users: faUsers,
    percent: faPercent,
    file: faFileLines,
    pen: faPen,
    comment: faComment,
    clipboard: faClipboardCheck,
    check: faCircleCheck,
    warning: faTriangleExclamation,
};
